import authService from '../../services/authService'
import Vue from 'vue'

const state = {
    user: null,
    isAuthenticated: false,
    loading: false,
    showAuthModal: false,
}

const getters = {
    currentUser: (state) => state.user,
    isAuthenticated: (state) => state.isAuthenticated,
    authLoading: (state) => state.loading,
    showAuthModal: (state) => state.showAuthModal,
}

const actions = {
    async login({ commit }, credentials) {
        commit('SET_LOADING', true)
        try {
            const user = await authService.login(credentials)
            commit('SET_USER', user)
            return user
        } catch (error) {
            console.error('Login failed', error)
            throw error
        } finally {
            commit('SET_LOADING', false)
        }
    },
    async logout({ commit }) {
        console.log('📤 Logout action called')
        try {
            await authService.logout()
        } catch (error) {
            // Ignore errors, we'll clear the user anyway
            console.log('Logout service error (ignored):', error.message)
        } finally {
            // Always clear user state, even if backend logout fails
            commit('CLEAR_USER')
        }
    },
    async checkSession({ commit }) {
        try {
            const user = await authService.checkSession()
            if (user) {
                commit('SET_USER', user)
            }
        } catch (error) {
            commit('CLEAR_USER')
        }
    },
    async forgotPassword({ commit }, email) {
        commit('SET_LOADING', true)
        try {
            const response = await authService.forgotPassword(email)
            return response
        } finally {
            commit('SET_LOADING', false)
        }
    },
    async resetPassword({ commit }, data) {
        commit('SET_LOADING', true)
        try {
            const response = await authService.resetPassword(data)
            return response
        } finally {
            commit('SET_LOADING', false)
        }
    },
}

const mutations = {
    SET_USER(state, user) {
        console.log('🔵 SET_USER mutation:', user)
        Vue.set(state, 'user', user)
        Vue.set(state, 'isAuthenticated', true)
    },
    CLEAR_USER(state) {
        console.log('🔴 CLEAR_USER mutation - clearing auth state')
        Vue.set(state, 'user', null)
        Vue.set(state, 'isAuthenticated', false)
    },
    SET_LOADING(state, status) {
        state.loading = status
    },
    SET_SHOW_AUTH_MODAL(state, status) {
        state.showAuthModal = status
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
